<template>
  <BaseConfirmation
    :description="message"
    confirm-label="Complete payment"
    cancel-label="Go back"
    :is-showing="isRevealed"
    @confirm="confirm"
    @cancel="cancel"
  />
</template>

<script setup lang="ts">
import { useConfirmDialog } from "@vueuse/core"

const { formatToMerchantCurrencyString } = useCurrency()
const { reveal, isRevealed, confirm, cancel, onReveal } =
  useConfirmDialog<{ amountRemaining: number }>()

defineExpose({
  reveal,
})

const message = ref("")

onReveal(({ amountRemaining }) => {
  message.value = `Payment still has ${formatToMerchantCurrencyString(
    amountRemaining
  )} outstanding. Are you sure you want to complete anyway?`
})
</script>
